// Shared formatters for season/harvest alerts — used by BOTH the map tooltip
// (WeatherPopups.RegionPopupContent) and the Harvest Alerts side panel
// (MapSidebar.HarvestAlertsList) so the two surfaces stay identical.

// "3 weeks ahead / behind" derived from the signed week delta.
// Convention: negative = ahead/earlier, positive = behind/later.
export const formatHarvestDelta = (weeksDelta) => {
  const n = weeksDelta == null ? null : Number(weeksDelta);
  if (n == null || !Number.isFinite(n) || n === 0) return 'On schedule';
  return `${Math.abs(n)} week${Math.abs(n) === 1 ? '' : 's'} ${n < 0 ? 'ahead' : 'behind'}`;
};

// Compact tonnage: 1_250_000 -> "1.3M tons", 42_000 -> "42K tons". null if not a number.
const _tonsFmt = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });
export const formatTonsCompact = (tons) => {
  const v = Number(tons);
  return Number.isFinite(v) ? `${_tonsFmt.format(v)} tons` : null;
};
